
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';

interface TermsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const TermsModal = ({ open, onOpenChange }: TermsModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>Termos e Condições - Ink Webtoons Store</DialogTitle>
          <DialogDescription>
            Leia atentamente os termos antes de prosseguir
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <div className="space-y-4 text-sm">
            <section>
              <h3 className="font-semibold text-base mb-2">1. Aceitação dos Termos</h3>
              <p>
                Ao criar uma loja na plataforma Ink Webtoons, você concorda em cumprir estes termos e condições.
                Estes termos constituem um acordo legal entre você e a Ink Webtoons.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">2. Elegibilidade</h3>
              <p>
                Para criar uma loja, você deve ter pelo menos 18 anos ou ter permissão dos pais/responsáveis.
                Você deve fornecer informações precisas e completas durante o cadastro.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">3. Propriedade Intelectual</h3>
              <p>
                Você é responsável por garantir que todos os designs e conteúdos enviados são de sua propriedade
                ou que você possui os direitos necessários para comercializá-los. É proibido usar conteúdo
                protegido por direitos autorais sem autorização.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">4. Qualidade dos Produtos</h3>
              <p>
                Todos os designs devem atender aos padrões de qualidade da plataforma. Reservamo-nos o direito
                de remover produtos que não atendam aos nossos critérios de qualidade ou que violem estas diretrizes.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">5. Pagamentos e Comissões</h3>
              <p>
                A Ink Webtoons retém uma comissão sobre as vendas realizadas através da plataforma.
                Os pagamentos aos vendedores são processados mensalmente, sujeitos aos nossos termos de pagamento.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">6. Responsabilidades do Vendedor</h3>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Manter informações de contato atualizadas</li>
                <li>Responder a dúvidas dos clientes em tempo hábil</li>
                <li>Garantir a originalidade dos designs</li>
                <li>Cumprir prazos de entrega quando aplicável</li>
              </ul>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">7. Conteúdo Proibido</h3>
              <p>
                É proibido comercializar conteúdo que seja ofensivo, discriminatório, violento, obsceno
                ou que viole direitos de terceiros. Designs que promovam atividades ilegais também são proibidos.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">8. Suspensão e Encerramento</h3>
              <p>
                Reservamo-nos o direito de suspender ou encerrar contas que violem estes termos.
                Em caso de violação grave, a conta pode ser encerrada imediatamente sem aviso prévio.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">9. Modificações dos Termos</h3>
              <p>
                Estes termos podem ser modificados a qualquer momento. As alterações entrarão em vigor
                imediatamente após a publicação. É sua responsabilidade revisar periodicamente os termos.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base mb-2">10. Contato</h3>
              <p>
                Para dúvidas sobre estes termos, entre em contato conosco através do e-mail:
                legal@inkwebtoons.com
              </p>
            </section>

            <div className="border-t pt-4 mt-6">
              <p className="text-xs text-muted-foreground">
                Última atualização: Janeiro de 2025
              </p>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
